import React from 'react';

import { styled } from '@uhg-abyss/web/tools/styled';
import { useContentConfig } from '../hooks';
import PromptOption from './PromptOption';
import GreetingMessage from './GreetingMessage';

interface ChatPromptOptionsProps {
  onPromptPress: (identifier: string, title: string) => void;
}

const ChatPromptOptions: React.FC<ChatPromptOptionsProps> = ({ onPromptPress }) => {
  const { data: config } = useContentConfig();
  const promptOptions = config?.content?.promptOptions || [];

  return (
    <DashboardContainer>
      <GreetingMessage />

      <OptionsContainer>
        {promptOptions.map((option) => (
          <PromptOption
            key={option.identifier}
            text={option.title}
            onPress={() => onPromptPress(option.identifier, option.title)}
          />
        ))}
      </OptionsContainer>
    </DashboardContainer>
  );
};

const DashboardContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  justifyContent: 'space-between',
  padding: '$core.spacing.800 0',
});

const OptionsContainer = styled('div', {
  display: 'grid',
  justifyContent: 'flex-end',
  gap: '$core.spacing.150',
});

export default ChatPromptOptions;
